:host {
  --aha-alert__border-opacity: 0.3;

  display: block;
  border-radius: var(--Common--border-radius);
  background-color: var(--aha-alert__background-color);
  border: 1px solid var(--aha-alert__border-color);
  border-radius: var(--Common--border-radius);
  outline: 0;
  font-size: var(--aha-alert__font-size, 13px);
  min-width: min(300px, 100%);
}
:host([aria-hidden='true']) {
  display: none;
}

:host * {
  box-sizing: border-box;
}

:host([type='warning']) {
  --aha-alert__background-color: var(--theme-alert-warning-background);
  --aha-alert__border-color: rgb(
    var(--theme-rgb-alert-warning-border),
    var(--aha-alert__border-opacity)
  );
  --aha-alert__icon-color: var(--theme-alert-warning-border);
}

:host([type='success']) {
  --aha-alert__background-color: var(--theme-alert-success-background);
  --aha-alert__border-color: rgb(
    var(--theme-rgb-alert-success-border),
    var(--aha-alert__border-opacity)
  );
  --aha-alert__icon-color: var(--theme-alert-success-border);
}

:host([type='danger']) {
  --aha-alert__background-color: var(--theme-alert-danger-background);
  --aha-alert__border-color: rgb(
    var(--theme-rgb-alert-danger-border),
    var(--aha-alert__border-opacity)
  );
  --aha-alert__icon-color: var(--theme-alert-danger-border);
}

:host([type='info']) {
  --aha-alert__background-color: var(--theme-alert-info-background);
  --aha-alert__border-color: rgb(
    var(--theme-rgb-alert-info-border),
    var(--aha-alert__border-opacity)
  );
  --aha-alert__icon-color: var(--theme-alert-info-border);
}

:host([type='ai']) {
  --aha-alert__background-color: var(--theme-alert-ai-background);
  --aha-alert__border-color: rgb(
    var(--theme-rgb-alert-ai-border),
    var(--aha-alert__border-opacity)
  );
  --aha-alert__icon-color: var(--theme-alert-ai-icon-color);
}

:host([type='info-settings']) {
  --aha-alert__background-color: var(--theme-alert-info-settings-background);
  --aha-alert__border-color: rgb(
    var(--theme-rgb-alert-info-settings-border),
    var(--aha-alert__border-opacity)
  );
  --aha-alert__icon-color: var(--theme-alert-info-settings-border);
}

:host([size='mini']) {
  --aha-alert__padding: 4px 6px;
  --aha-alert__font-size: 12px;
  --aha-alert__icon-font-size: 12px;
  --aha-alert__align-items: center;
  text-wrap: nowrap;
  min-width: unset;
}

#heading {
  display: block;
  font-weight: bold;
  margin-bottom: var(--spacer-1);
}

#layout {
  padding: var(--aha-alert__padding, var(--spacer-4) var(--spacer-3));
  display: flex;
  gap: var(--spacer-3);
  width: inherit;
  height: 100%;
  align-items: var(--aha-alert__align-items, stretch);
}

#close {
  order: 1;
  flex-shrink: 1;
  align-self: var(--aha-alert__align-items, flex-start);
}
#icon {
  flex-shrink: 1;
}
#content {
  flex: 1 1;
}

#close button,
:host slot[name='close']::slotted(button) {
  color: rgba(var(--theme-rgb-tertiary-text), 0.8);
  padding: var(--spacer-2);
  margin: calc(-1 * var(--spacer-2)) !important; /* Need to override bootstrap value. */
  cursor: pointer;
  background: none;
  border: 0;
  font-size: var(--aha-alert__font-size, 13px);
}
#close button:is(:hover, :focus),
:host slot[name='close']::slotted(button:is(:hover, :focus)) {
  color: var(--theme-primary-text);
}
#icon,
:host ::slotted([slot='icon']) {
  font-size: var(--aha-alert__icon-font-size, 18px);
  color: var(--aha-alert__icon-color);
  line-height: 1ex !important; /* Ensure that the icon has the same baseline as the text on the right, even though it is larger. */
}
